import * as React from "react"
import { UserIdContext } from "../App"
import LinkedInIcon from "../Assets/linkedin.svg"


interface ITrainingCard {
    id: Number
    name: string,
    price: Number,
    summary: string,
    presentationVideo: string,
    allowedUsers: Array<any>
}

//This component create the card display in Home Component list of training
export const TrainingCard: React.FunctionComponent<ITrainingCard> = (props) => {

    const {currentUserId, setCurrentUserId} = React.useContext(UserIdContext)

    let presentationUrl = props.presentationVideo
    let presentationId = presentationUrl.split('/')[3]
    let userIdAllowed = props.allowedUsers.map((longId) => {
        return parseInt(longId.split('/')[4])
    })

    const checkOwned = () => {
        if (userIdAllowed.includes(currentUserId)) {
            return (
                <div className="Price">Formation acquise</div>
            )
        }
        else {
            return(
                <div className="Price">Prix: {props.price}€</div>
            )
        }
    }

    return(
        <div className="TrainingCard">
            <h2>{props.name}</h2>
            {checkOwned()}
            <div className="CenterVideo"><iframe className="CenterVideoItem" src={`https://player.vimeo.com/video/${presentationId}`} allow="autoplay; fullscreen" allowFullScreen></iframe></div>
            <h3>Description : </h3>
            <div className="Description">{props.summary}</div>   
            <div className="TdIcon">Cliquez pour plus d'informations</div>
        </div>
    )
}